import axios from 'axios';
import { IS_BROWSER, IS_BROWSER_MAIN_THREAD } from './../consts.js';

export default async function createClassInstance(gudhub, module_id, js_url, css_url, nodeWindow) {

    try {

        // Check if there is url to javascript file of module

        if (!js_url) {
            console.error(`JS link must be provided for this data type - ${module_id}`);
        }

        // Import module using dynamic import

        let downloadModule = (url) => {
            if (
                !IS_BROWSER_MAIN_THREAD
            ) {
                global.window = proxy;
                global.document = nodeWindow.document;
                global.Element = nodeWindow.Element;
                global.CharacterData = nodeWindow.CharacterData;
                global.this = proxy;
                global.self = proxy;
                global.Blob = nodeWindow.Blob;
                global.Node = nodeWindow.Node;
                global.navigator = nodeWindow.navigator;
                global.HTMLElement = nodeWindow.HTMLElement;
                global.XMLHttpRequest = nodeWindow.XMLHttpRequest;
                global.WebSocket = nodeWindow.WebSocket;
                global.crypto = nodeWindow.crypto;
                global.DOMParser = nodeWindow.DOMParser;
                global.Symbol = nodeWindow.Symbol;
                global.document.queryCommandSupported = (command) => {
                    console.log('QUERY COMMAND SUPPORTED: ', command);
                    return false;
                }
                global.angular = angular;
            }
            return new Promise(async (resolve) => {
                let moduleData = await axios.get(url).catch(err => {
                    console.log(`Failed to fetch: ${url} in ghconstructor. Module id: ${module_id}`);
                })

                let encodedJs = encodeURIComponent(moduleData.data);

                let dataUri = 'data:text/javascript;charset=utf-8,' + encodedJs;

                resolve(dataUri);
            })
        }

        let moduleData = await downloadModule(js_url);

        let module;

        try {
            module = await import(/* webpackIgnore: true */moduleData);
        } catch (err) {
            console.log(`Error while importing module: ${module_id}`);
            console.log(err);
        }

        // Creating class from imported module

        let importedClass = new module.default(module_id);

        // Check if there is url to css file of module
        // If true, and there is no css for this data type, than create link tag to this css in head

        if (
            css_url &&
            IS_BROWSER
        ) {
            const linkTag = document.createElement('link');
            linkTag.href = css_url;
            linkTag.setAttribute('data-module', module_id);
            linkTag.setAttribute('rel', 'stylesheet');
            document.getElementsByTagName('head')[0].appendChild(linkTag);
        }

        let result = {
            type: module_id,

            //*************** GET TEMPLATE ****************//

            getTemplate: function (ref, changeFieldName, displayFieldName, field_model, appId, itemId) {
                let displayFieldNameChecked = displayFieldName === 'false' ? false : true;
                return importedClass.getTemplate(ref, changeFieldName, displayFieldNameChecked, field_model, appId, itemId);
            },

            //*************** GET DEFAULT VALUE ****************//

            getDefaultValue: function (fieldModel, valuesArray, itemsList, currentAppId) {
                return new Promise(async (resolve) => {
                    let getValueFunction = importedClass.getDefaultValue;
                    if (getValueFunction) {
                        let value = await getValueFunction(fieldModel, valuesArray, itemsList, currentAppId);
                        resolve(value);
                    } else {
                        resolve(null);
                    }
                });
            },

            //*************** GET SETTINGS ****************//

            getSettings: function (scope, settingType, fieldModels) {
                return importedClass.getSettings(scope, settingType, fieldModels);
            },

            //*************** FILTER****************//

            filter: {
                getSearchOptions: function (fieldModel) {
                    let d_type = importedClass;
                    if (d_type.filter && d_type.filter.getSearchOptions) {
                        return importedClass.filter.getSearchOptions(fieldModel);
                    }
                    return [];
                },
                getDropdownValues: function () {
                    let d_type = importedClass;
                    if (d_type.filter && d_type.filter.getDropdownValues) {
                        return d_type.filter.getDropdownValues();
                    } else {
                        return [];
                    }
                }
            },

            //*************** GET INTERPRETATION ****************//

            getInterpretation: function (value, interpretation_id, dataType, field, itemId, appId) {
                return new Promise(async (resolve) => {
                    let currentDataType = importedClass;

                    try {
                        let interpr_arr = await currentDataType.getInterpretation(gudhub, value, appId, itemId, field, dataType);
                        let data = interpr_arr.find((item) => item.id == interpretation_id) || interpr_arr.find((item) => item.id == 'default');

                        let result = await data.content()

                        resolve({ html: result });
                    } catch (error) {
                        console.log(`ERROR IN ${module_id}`, error);
                        resolve({ html: '<span>no interpretation</span>' })
                    }
                });
            },

            //*************** GET INTERPRETATIONS LIST ****************//

            getInterpretationsList: function (field_value, appId, itemId, field) {
                return importedClass.getInterpretation(field_value, appId, itemId, field);
            },

            //*************** GET INTERPRETATED VALUE ****************//

            getInterpretatedValue: function (field_value, field_model, appId, itemId) {
                return new Promise(async (resolve) => {
                    let getInterpretatedValueFunction = importedClass.getInterpretatedValue;
                    if (getInterpretatedValueFunction) {
                        let value = await getInterpretatedValueFunction(field_value, field_model, appId, itemId);
                        resolve(value);
                    } else {
                        resolve(field_value);
                    }
                });
            },

            //*************** ON MESSAGE ****************//

            onMessage: function(appId, userId, response) {
                return new Promise(async (resolve) => {
                    const onMessageFunction = importedClass.onMessage;
                    if(onMessageFunction) {
                        const result = await onMessageFunction(appId, userId, response);
                        resolve(result);
                    }
                    resolve(null);
                })
            },

            //*************** EXTEND CONTROLLER ****************//

            extendController: function (actionScope) {
                importedClass.getActionScope(actionScope);
            },

            //*************** RUN ACTION ****************//

            runAction: function (scope) {
                try {
                    importedClass.runAction(scope);
                } catch (e) {

                }
            },

            //*************** GET WINDOW SCOPE ****************//

            getWindowScope: function (windowScope) {
                return importedClass.getWindowScope(windowScope);
            },

            //*************** GET WINDOW HTML ****************//

            getWindowHTML: function (scope) {
                return importedClass.getWindowHTML(scope);
            },
        }

        return result;

    } catch (err) {
        console.log(err);
        console.log(`Failed in createClassInstance (ghconstructor). Module id: ${module_id}. JS url: ${js_url}`);
    }
}
